import SetupSegment from './SetupSegment';

export default SetupSegment;
